import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "controlsToggleExtraContent",
      options: {
        controlsPosition: "bottom",
        controls: [{ type: "button", options: {}, items: [{ name: "Pressure field" }, { name: "Intensity map" }] }],
        extraContent: [[], []],
        components: [
          [
            {
              variant: "layout",
              data: {
                type: "table",
                options: {
                  cols: 2,
                  rows: 1,
                  colsSize: [3, 1],
                  components: [
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "video",
                            options: {
                              controls: false,
                              autoplay: true,
                              loop: true,
                              src: `${config.ASSETS_URL}/01/14/principle/quad-longi/pressure-quad-longi-freq-5000Hz-d-8cm.m4v`,
                            },
                          },
                          styles: {
                            padding: "4.85% 0px",
                            width: "80% ",
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: { src: `${config.ASSETS_URL}/01/14/principle/quad-longi/quad-longi.svg` },
                          },
                        },
                      },
                    ],
                  ],
                },
              },
            },
          ],
          [
            {
              variant: "layout",
              data: {
                type: "table",
                options: {
                  cols: 2,
                  rows: 1,
                  colsSize: [3, 1],
                  components: [
                    [
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: {
                              src: `${config.ASSETS_URL}/01/14/principle/quad-longi/intensity-quad-longi-freq-5000Hz-d-8cm.png`,
                            },
                          },
                          styles: {
                            padding: "4.85% 0px",
                            width: "80% ",
                          },
                        },
                      },
                      {
                        variant: "blockContainer",
                        data: {
                          block: {
                            type: "image",
                            options: { src: `${config.ASSETS_URL}/01/14/principle/quad-longi/quad-longi.svg` },
                          },
                        },
                      },
                    ],
                  ],
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
